module.exports = __webpack_public_path__ + "static/media/Loading_web@3x.06d4a87c.png";